import { IsArray, IsDate, IsDefined, IsInt, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export class RecipeSubstitutionDetailsDto {
  @IsDefined()
  @IsInt()
  id: number;

  @IsDefined()
  @IsDate()
  effectiveDate: string;
}

export class StockSubstitutionDto {
  @IsDefined()
  @IsInt()
  oldStockId: number;

  @IsDefined()
  @IsInt()
  newStockId: number;

  @IsDefined()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => RecipeSubstitutionDetailsDto)
  recipeIds: RecipeSubstitutionDetailsDto[];
}

